module.exports = __webpack_public_path__ + "img/diversion.514c8b03.png";